export default __webpack_public_path__ + "static/media/fangxin.191c69de.jpg";